import { Empty } from "antd";
const EmptyData = ({ text = "بدون دیتا" }) => {
  return <Empty description={text} image={Empty.PRESENTED_IMAGE_SIMPLE} />;
};

export default EmptyData;
